const TermsPage = () => {
  return (
    <article
      className={`prose lg:prose-lg dark:prose-invert mx-auto p-6 bg-white dark:bg-neutral-900 rounded-2xl shadow-sm `}
    >
      <header>
        <h1 className="text-2xl font-semibold">
          Términos y Condiciones del Sorteo
        </h1>
      </header>

      <section>
        <h2>Primera. - Organización</h2>
        <p>
          El presente sorteo es organizado por{" "}
          <strong className="font-bold">Beeapp Ecuador Cía. Ltda.</strong>, con domicilio en Ecuador,
          en adelante “la organización”. La participación en este sorteo implica
          la aceptación plena y sin reservas de los presentes términos y
          condiciones.
        </p>
      </section>

      <section>
        <h2>Segunda. - Duración</h2>
        <p>
          El sorteo se llevará a cabo{" "}
          <strong className="font-bold">
            una vez se complete la venta total de los boletos disponibles
          </strong>
          . No se realizará el sorteo mientras existan boletos sin vender.
        </p>
      </section>

      <section>
        <h2>Tercera. - Elegibilidad</h2>
        <ul>
          <li>
            Puede participar cualquier persona natural, nacional o extranjera.
          </li>
          <li>
            Para la entrega de premios, los ganadores deberán ser{" "}
            <strong className="font-bold">mayores de edad (18 años)</strong> o estar representados
            legalmente por su tutor o representante.
          </li>
        </ul>
      </section>

      <section>
        <h2>Cuarta. - Asignación de números</h2>
        <ul>
          <li>
            Los boletos se adquieren únicamente a través de la plataforma en
            línea oficial de la organización.
          </li>
          <li>
            • Los números se asignan de manera{" "}
            <strong className="font-bold">única y aleatoria</strong> por el sistema, garantizando
            transparencia en la asignación.
          </li>
          <li>Cada boleto tiene un valor único y no se admiten duplicados.</li>
        </ul>
      </section>

      <section>
        <h2>Quinta. - Premios</h2>
        <p>
          Los premios del sorteo serán aquellos anunciados previamente en la
          publicidad oficial y canales de comunicación de la organización. Cada
          sorteo podrá incluir uno o varios premios principales y premios
          adicionales en efectivo o en especie, según lo establecido en las
          bases publicadas.
        </p>

        <details className="mb-4">
          <summary className="cursor-pointer font-medium">
            5.1 Entrega de premios
          </summary>
          <ul>
            <li>
              Todos los premios serán entregados a nombre del ganador
              debidamente acreditado, cumpliendo con los procesos legales y
              administrativos que correspondan a cada tipo de premio.
            </li>
            <li>
              En el caso de premios en bienes muebles (vehículos, motocicletas,
              electrodomésticos, etc.), serán entregados con la documentación
              necesaria para su legal uso, salvo que se indique lo contrario en
              la convocatoria del sorteo.
            </li>
            <li>
              En el caso de premios en inmuebles, se procederá a la
              transferencia de dominio conforme a la ley vigente.
            </li>
            <li>
              Los premios en efectivo serán entregados mediante transferencia
              bancaria, depósito o en efectivo, de acuerdo con lo acordado con
              el ganador y las disposiciones de la organización.
            </li>
            <li>
              Todos los gastos adicionales derivados de la aceptación y disfrute
              del premio (impuestos, matriculación, gastos notariales, trámites
              legales u otros) serán de exclusiva responsabilidad del ganador,
              salvo que se establezca expresamente lo contrario en las bases del
              sorteo.
            </li>
          </ul>
        </details>
        <details className="mb-4">
          <summary className="cursor-pointer font-medium">
            5.2 Condiciones adicionales
          </summary>
          <ul>
            <li>
              La entrega de premios deberá ser grabada, fotografiada y publicada
              como evidencia de transparencia.
            </li>
            <li>
              El ganador autoriza a la organización a utilizar su imagen, nombre
              y testimonio en material promocional y publicitario relacionado
              con el sorteo, sin derecho a compensación adicional.
            </li>
          </ul>
        </details>
      </section>

      <section>
        <h2>Sexta. - Selección de los ganadores</h2>
        <ul>
          <li>
            Los números ganadores se determinarán en base a las{" "}
            <strong className="font-bold">
              últimas cifras del sorteo oficial de la Lotería Nacional del
              Ecuador
            </strong>{" "}
            inmediatamente posterior a la venta total de los boletos.
          </li>
          <li>
            Cada premio se asignará de forma pública, transparente y
            verificable.
          </li>
        </ul>
      </section>
      <section>
        <h2>Séptima. - Notificación y publicación de resultados</h2>
        <ul>
          <li>
            Los resultados serán publicados en las redes sociales y canales
            oficiales de la organización.
          </li>
          <li>
            Los ganadores serán notificados mediante los datos registrados al
            comprar el boleto (correo electrónico, WhatsApp o llamada
            telefónica).
          </li>
          <li>
            En caso de no poder contactar al ganador en un plazo de 30 días, el
            premio quedará bajo custodia de la organización hasta que se
            acredite el derecho legítimo.
          </li>
        </ul>
      </section>

      <section>
        <h2>Octava. - Pagos y reembolsos</h2>
        <ul>
          <li>
            El participante deberá realizar el pago dentro del plazo establecido
            por el sistema.
          </li>
          <li>
            Los boletos adquiridos <strong className="font-bold">no son reembolsables ni transferibles</strong> bajo
            ningún concepto.
          </li>
          <li>
            La organización no se responsabiliza por pagos no reportados a
            tiempo ni por errores en los datos ingresados por el participante.
          </li>
        </ul>
      </section>

      <section>
        <h2>Novena. - Propiedad Intelectual</h2>
        <p>
          El contenido digital, marca e imagen del sorteo están protegidos por
          derechos de autor y propiedad intelectual. Su reproducción o uso no
          autorizado está prohibido.
        </p>
      </section>

      <section>
        <h2>Décima. - Condiciones generales</h2>
        <ul>
          <li>
            La compra de un boleto constituye aceptación total de estos términos
            y condiciones.
          </li>
          <li>
            La organización se reserva el derecho de modificar o actualizar las
            condiciones en caso de fuerza mayor o disposición legal,
            garantizando siempre la transparencia.
          </li>
          <li>
            Cualquier intento de fraude, falsificación o manipulación del
            sistema será sancionado con la anulación inmediata de la
            participación.
          </li>
        </ul>
      </section>

      <section>
        <h2>Undécima. - Contacto</h2>
        <p>
          Para consultas o reclamos, los participantes podrán comunicarse al
          correo:{"  "}
          <a href="mailto:info@correos-bee.com" className="underline font-bold">
            info@correos-bee.com
          </a>{" "}
          o vía WhatsApp al número oficial de la organización (<strong className="font-bold">0981013666</strong>).
        </p>
      </section>

      {/* <footer className="text-sm text-neutral-500">
        <p>Última revisión: 15 de agosto de 2022</p>
      </footer> */}
    </article>
  );
};

export default TermsPage;
